import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import styles from "./ShipFromStoreDrawer.module.scss";
import { TickOutlined as Tick } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { InfoOutlined as Info } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined as Close } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useRef } from "react";
import { dispatchAnalyticsEvent } from "@/utils";

interface Props {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  isStandardDelivery: boolean;
}

export function ShipFromStoreDrawer({
  isDrawerOpen,
  setIsDrawerOpen,
  isStandardDelivery,
}: Props) {
  const isDrawerInteractionDispatched = useRef(false);

  function dispatchOverlayClosedEvent() {
    dispatchAnalyticsEvent("shipfromstore.overlayClosed", {}, {});
  }

  const handleClose = () => {
    setIsDrawerOpen(false);
    if (!isDrawerInteractionDispatched.current) {
      dispatchOverlayClosedEvent();
      isDrawerInteractionDispatched.current = true;
    }
  };
  return (
    <Drawer
      isOpen={isDrawerOpen}
      onClose={handleClose}
      heading="Delivery from store"
      className={styles.express}
    >
      <>
        <span className={styles.express__title}>
          <Info size="medium" className={styles.express__infoIcon} />
          How it works
        </span>
        <ul className={styles.express__list}>
          <li>
            You can only buy{" "}
            <span className={styles.express__bold}>1 item per order</span> using
            express checkout as one of our in-store Partners will pick, pack and
            send this item to you. Any other items in your basket will be saved
            there for you to buy later.
          </li>
          <li>
            Your order will be sent using{" "}
            <span className={styles.express__bold}>
              {isStandardDelivery
                ? "standard delivery at £4.50"
                : "free standard delivery"}
            </span>
            . Delivery is within 2 to 5 days, Monday to Saturday.
          </li>
          <li>
            <span className={styles.express__bold}>
              Special offers and promotions may not be available.
            </span>{" "}
            For example, some promotions are online only and cannot be fulfilled
            when we&apos;re sending the item from one of our stores.
          </li>
        </ul>
        <p className={styles.express__text}>
          We&apos;ll keep you updated on the progress of your order by email.
        </p>
      </>
    </Drawer>
  );
}
